<div class="onboarding-step-wrapper">
    <h2>Financial tax and currency settings</h2>
    <div class="onboarding-blurb">
        <p>Default currency and tax treatment can be set here.</p>
    </div>
    <ng-container *ngIf="!isLoading else showLoader">
        <div class="onboarding-prompt-wrapper">
            <form [formGroup]="financialForm" class="cas-flex-column">
                <acabim-form-block labelWidth="7" [labelAlign]="'right'" [colonize]="true" [shortFields]="true">
                    <acabim-form-input-wrapper>
                        <acabim-form-input-label>Currency</acabim-form-input-label>
                        <acabim-form-input-content>
                            <p-dropdown
                                appendTo="body"
                                formControlName="currency"
                                [options]="defaultCurrency"
                                placeholder="Select currency"
                                optionLabel="name"></p-dropdown>
                        </acabim-form-input-content>
                    </acabim-form-input-wrapper>
                    <acabim-form-input-wrapper>
                        <acabim-form-input-label>GST</acabim-form-input-label>
                        <acabim-form-input-content>
                            <p-dropdown
                                appendTo="body"
                                formControlName="tax"
                                [options]="taxType"
                                placeholder="Select tax type"
                                optionLabel="name"></p-dropdown>
                        </acabim-form-input-content>
                    </acabim-form-input-wrapper>
                </acabim-form-block>
                <button (click)="submit(true)" class="cas-button-action">Update</button>
            </form>
        </div>
    </ng-container>

    <ng-template #showLoader>
        <acabim-loading-view></acabim-loading-view>
    </ng-template>

</div>
